export default __webpack_public_path__ + "static/media/projectIcon.5086e855.png";